module.exports = "/assets/data/bf8c36740e8ffc20a9bb173b6e682bed-G76.data.json";